import { Pause } from 'lucide-react';
import { useId } from 'react';
import { POINT_VOCAL_CUES } from '@/utils/inlineVocalCues';
import type { EditorInsertKind } from '@/utils/editorDrag';
import EditorToolSection from './EditorToolSection';
interface Props {
  disabled: boolean;
  onInsert: (kind: EditorInsertKind) => void;
  onDragStart: (event: React.DragEvent, kind: EditorInsertKind) => void;
  onDragEnd: () => void;
}
export default function PointVocalCueTools(props: Props) {
  const instructionId=useId();
  return <EditorToolSection title="Vocal cues & pauses" grouped defaultOpen scroll={false}><fieldset disabled={props.disabled} className="performance-palette space-y-2" aria-label="Vocal cues and pauses" aria-describedby={instructionId}>
    <p id={instructionId} className="text-xs leading-4 text-muted-foreground">Drag an expression into the script where you want it to occur.</p>
    <div className="performance-deliveries" data-family="expression">
      {(['pause', ...POINT_VOCAL_CUES.map(c => `cue:${c}`)] as EditorInsertKind[]).map(kind => {
        const label = kind === 'pause' ? 'Pause' : kind.slice(4).replace(/^./, c => c.toUpperCase());
        return <button type="button" key={kind} draggable={!props.disabled} disabled={props.disabled}
          className="performance-delivery cursor-grab active:cursor-grabbing" aria-label={`Insert ${label.toLowerCase()} at cursor`}
          title={`Drag ${label.toLowerCase()} into the text, or place the cursor and click.`}
          onDragStart={e => props.onDragStart(e, kind)} onDragEnd={props.onDragEnd} onClick={() => props.onInsert(kind)}>
          {kind === 'pause' && <Pause className="mr-1 inline h-3 w-3" aria-hidden="true" />}{label}
        </button>;
      })}
    </div>
  </fieldset></EditorToolSection>;
}
